import { ChangeEvent, useEffect, useState } from 'react'
import { ModalControls } from './useModalControl'

export const useFile = ({
  modalControls,
}: {
  modalControls: ModalControls
}) => {
  const [uploadedImage, setUploadedImage] = useState<File>()
  const [previewModalOpen, setPreviewModalOpen] = useState<boolean>(false)

  const { handleModalOpen, modal, modalOpen } = modalControls

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return
    }

    const selectedFile = event.target.files[0]
    setUploadedImage(selectedFile)

    handleModalOpen('imageUploadPreviewModal')
  }

  const reset = () => {
    setUploadedImage(undefined)
  }

  useEffect(() => {
    setPreviewModalOpen(modal === 'imageUploadPreviewModal' && modalOpen)
  }, [modal, modalOpen])

  return { handleFileChange, uploadedImage, previewModalOpen, reset }
}
